import { useEffect, useState } from "react";
import { currentProductionHost } from "libs/productionOrigins";

const useHotjar = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!isLoaded) {
      const host = currentProductionHost();

      if (host) hotjarLoader(host.hotjarId)();

      setIsLoaded(true);
    }
  }, [isLoaded, setIsLoaded]);
};

export default useHotjar;

const hotjarLoader =
  (clientId) =>
  (
    h = window,
    o = document,
    t = "https://static.hotjar.com/c/hotjar-",
    j = ".js?sv=",
    a,
    r,
  ) => {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: clientId, hjsv: 6 };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  };
